<script setup lang="ts">
import { ClickableTypography, TypographyItem } from '../Typography'

type Props = {
    isVisible?: boolean
    field?: string
    label?: string
    url?: string
    idKey?: string
}

withDefaults(defineProps<Props>(), { isVisible: true })
</script>

<template>
    <b-table-column
        :visible="isVisible"
        :field="field"
        :label="label"
        class="column"
        v-bind="$attrs"
        v-slot="props">
        <slot v-bind="props">
            <ClickableTypography
                v-if="url"
                :label="props.row[field ?? '']"
                :href="`${url}/${props.row[idKey ?? 'id']}`"
                class="clickable-typography" />
            <TypographyItem v-else-if="field" :label="props.row[field ?? '']" />
        </slot>
    </b-table-column>
</template>
